import React from 'react'
import NetProfitFilter from '../filters/NetProfitFilter'
import FilterComponentParams from '../filters/types/FilterComponentParams'
import AbsoluteDrawdownFilter from '../filters/AbsoluteDrawdownFilter'
import DateRangeFilter from '../filters/DateRangeFilter'
import FilterButton from './FilterButton'
import FilterHeaderSection from '../filters/components/FilterHeaderSection'
import Box from '@mui/material/Box'
import RelativeDrawdownFilter from '../filters/RelativeDrawdownFilter'
import DaysBacktestedFilter from '../filters/DaysBacktestedFilter'
import TriggerChartFilter from '../filters/TriggerChartFilter'
import SymbolSelectFilter from '../filters/SymbolSelectFilter'
import SortSelect from '../sort/SortSelect'
import { useTheme } from '@mui/material/styles'
import Button from '@mui/material/Button'
import { backtestFilterDefaultValues } from '../../../../contexts/ApplicationSuiteProvider'
import { useMediaQuery } from '@mui/material'

interface MoreFilterButtonProps extends FilterComponentParams {
  backtestSort: any
  setBacktestSort: (value: any) => void
}

function MoreFilterButton(props: MoreFilterButtonProps) {
  const { backtestFilters, setBacktestFilters, backtestSort, setBacktestSort } = props

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <FilterButton
      showOnlyIcon={true}
      menu={
        <Box
          sx={{
            height: 500,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 1,
              backgroundColor: theme.palette.background.custom3,
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.2)',
              marginBottom: '2px',
            }}
          >
            <FilterHeaderSection
              title={'Filters'}
              rightSlot={
                isMobile ? (
                  <SortSelect backtestSort={backtestSort} setBacktestSort={setBacktestSort} />
                ) : null
              }
            />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              overflowY: 'auto',
              marginBottom: '52px',
              backgroundColor: theme.palette.background.custom2,
            }}
          >
            <SymbolSelectFilter
              backtestFilters={backtestFilters}
              setBacktestFilters={setBacktestFilters}
            />
            <NetProfitFilter
              backtestFilters={backtestFilters}
              setBacktestFilters={setBacktestFilters}
            />
            <AbsoluteDrawdownFilter
              backtestFilters={backtestFilters}
              setBacktestFilters={setBacktestFilters}
            />
            <RelativeDrawdownFilter
              backtestFilters={backtestFilters}
              setBacktestFilters={setBacktestFilters}
            />
            <TriggerChartFilter
              backtestFilters={backtestFilters}
              setBacktestFilters={setBacktestFilters}
            />
            <DateRangeFilter
              backtestFilters={backtestFilters}
              setBacktestFilters={setBacktestFilters}
            />
            <DaysBacktestedFilter
              backtestFilters={backtestFilters}
              setBacktestFilters={setBacktestFilters}
            />
          </Box>
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              padding: '8px',
              backgroundColor: theme.palette.background.custom3,
              borderTop: `1px solid ${theme.palette.divider}`,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setBacktestFilters(backtestFilterDefaultValues)
              }}
            >
              Clear
            </Button>
          </Box>
        </Box>
      }
      label={'Filters'}
    />
  )
}

export default MoreFilterButton
